import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GlobalService {
  private dataTasaCambio = new BehaviorSubject<number>(0);

  constructor() { }

  set tc(value) {
    this.dataTasaCambio.next(value);
  }

  get tc() {
    return this.dataTasaCambio.value;
  }

}
